"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MenuItemContent;
exports.styles = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _MenuContext = _interopRequireDefault(require("./MenuContext"));

var _MenuExpanderIcon = _interopRequireDefault(require("./MenuExpanderIcon"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var styles = function styles(theme) {
  return {
    listItem: {
      textTransform: 'uppercase',
      lineHeight: '1.5',
      fontSize: theme.typography.body1.fontSize
    },
    listItemImage: {
      width: '40px',
      height: '40px',
      marginRight: 0
    },
    listItemIcon: {
      marginRight: 0,
      minWidth: 0
    },
    loadingIcon: {
      display: 'block'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles, {
  name: 'RSFMenuItemContent'
});

function MenuItemContent(props) {
  var _useContext = (0, _react.useContext)(_MenuContext["default"]),
      renderItemContent = _useContext.renderItemContent,
      onItemClick = _useContext.onItemClick;

  var classes = useStyles(props);
  var item = props.item,
      depth = props.depth,
      leaf = props.leaf,
      listItemProps = props.listItemProps;
  var contents;

  if (renderItemContent) {
    contents = renderItemContent(item, leaf);
  }

  if (!contents) {
    if (leaf) {
      contents = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item.image && /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement("img", {
        className: classes.listItemImage,
        alt: item.text,
        src: item.image
      })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
        primary: item.text,
        disableTypography: true
      }));
    } else {
      contents = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, item.image && /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement("img", {
        className: classes.listItemImage,
        alt: item.text,
        src: item.image
      })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
        className: classes.listItem,
        primary: item.text,
        disableTypography: true
      }), /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
        className: classes.listItemIcon
      }, item.loading ? /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
        style: {
          height: 24,
          width: 24,
          padding: 4
        },
        color: "secondary",
        className: classes.loadingIcon
      }) : /*#__PURE__*/_react["default"].createElement(_MenuExpanderIcon["default"], props)));
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], (0, _extends2["default"])({
    onClick: leaf ? null : onItemClick.bind(null, item, depth),
    button: true,
    divider: true,
    classes: {
      root: (0, _clsx["default"])(classes.listItem, item.className)
    }
  }, listItemProps), contents);
}

MenuItemContent.propTypes = {
  /**
   * Additional props for the underlying ListItem
   */
  listItemProps: _propTypes["default"].object
};
